let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("f2Qn3")).then(() => parcelRequire('iQgoo'));